// src/pages/GroupLGBTQIA.js
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Grid, Card, CardActionArea, CardContent, Typography } from '@mui/material';

const CardTile = ({ title, subtitle, to }) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const go = () => {
    const citizenId = params.get('citizenId');
    navigate(citizenId ? `${to}?citizenId=${encodeURIComponent(citizenId)}` : to);
  };
  return (
    <Card className="rounded-2xl shadow-md">
      <CardActionArea onClick={go}>
        <CardContent>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary">{subtitle}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default function GroupLGBTQIA() {
  return (
    <Box className="p-6">
      <Typography variant="h5" sx={{ mb: 2 }}>
        LGBTQIA+ Care
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <CardTile
            title="Inclusive Intake"
            subtitle="Chosen name, pronouns, identity, safety"
            to="/dashboard/clinical/lgbtqia/intake"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardTile
            title="Care Bundle"
            subtitle="PrEP/PEP, STI panel, vaccination prompts"
            to="/dashboard/clinical/lgbtqia/care-bundle"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardTile
            title="Resources"
            subtitle="Local services and helplines"
            to="/dashboard/clinical/lgbtqia/resources"
          />
        </Grid>
      </Grid>
    </Box>
  );
}
